export default __webpack_public_path__ + "static/media/ic_modal_close.82eeaafb.svg";